import { SystemProps } from '@chakra-ui/styled-system';
import Box from '@prezzee/ribbon-ui/lib/components/Box';
import Image from '@prezzee/ribbon-ui/lib/components/Image';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';

type IconTagProps = {
  text: string;
  iconUrl: string;
  boldText: boolean;
};

const IconTag = ({ text, iconUrl, boldText }: IconTagProps) => (
  <Box {...containerStyles}>
    <Image src={iconUrl} margin="2" width="4" alt={text} />
    <Typography variant="body2" fontWeight={boldText ? 'bold' : 'normal'} {...textStyles}>
      {text}
    </Typography>
  </Box>
);

const containerStyles: SystemProps = {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'lilac.50',
  borderRadius: '100px',
  width: 'fit-content',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '0.5rem',
  marginRight: '0.5rem',
};

const textStyles: SystemProps = {
  paddingRight: 2,
  marginBottom: '3px',
  color: 'purple.400',
  lineHeight: '3',
};

export default IconTag;
